document.addEventListener('DOMContentLoaded', function () {
  var nav = document.querySelector('.site-nav');
  if (nav) window.addEventListener('scroll', function () { nav.classList.toggle('scrolled', window.scrollY > 10); });
  var burger = document.querySelector('.nav-burger'), mob = document.querySelector('.mobile-nav');
  if (burger && mob) burger.addEventListener('click', function () {
    mob.classList.toggle('open');
    document.body.style.overflow = mob.classList.contains('open') ? 'hidden' : '';
  });
  var slides = document.querySelectorAll('.hero-slide'), dots = document.querySelectorAll('.hero-dot');
  if (slides.length > 1) {
    var cur = 0;
    var go = function (n) {
      slides[cur].classList.remove('active'); if (dots[cur]) dots[cur].classList.remove('active');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active'); if (dots[cur]) dots[cur].classList.add('active');
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    setInterval(function () { go(cur + 1); }, 5000);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Advisory tabs
  document.querySelectorAll('.advisory-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.advisory-tab').forEach(function (t){t.classList.remove('active');});
      document.querySelectorAll('.advisory-panel').forEach(function (p){p.classList.remove('active');});
      tab.classList.add('active');
      var el = document.getElementById(tab.dataset.panel);
      if (el) el.classList.add('active');
    });
  });
  // Newsletter (demo feedback)
  document.querySelectorAll('.newsletter-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = form.querySelector('button'); if(!b) return;
      b.textContent = 'Subscribed \u2713'; b.style.background = '#2d7a3a';
      setTimeout(function(){ b.textContent='Subscribe'; b.style.background=''; }, 3000);
    });
  });
  // Smooth scroll for in-page anchors
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({behavior:'smooth',block:'start'}); }
    });
  });
});
